import { IApiError } from '@/models/apiError.model';
import { IFeed } from '@/models/feeds.model';
import { IPagination } from '@/models/pagination.model';
import { TGetFeedsQuery } from '../helpers/types';

export const FEEDS_SLICE_NAME = 'feeds';

export interface FeedsListState {
  feedsList: {
    data: IFeed[];
    meta: IPagination;
  } | null;
  isLoading: boolean;
  error: IApiError | null;
  query: TGetFeedsQuery | null;
}

export const initialState: FeedsListState = {
  feedsList: null,
  isLoading: false,
  query: null,
  error: null,
};
